import * as echarts from 'echarts/core';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import {
    PieChart
} from 'echarts/charts';
import {
    CanvasRenderer
} from 'echarts/renderers';

echarts.use(
    [TitleComponent, TooltipComponent, LegendComponent, PieChart, CanvasRenderer]
);

export function pieChart(nodeDOM,params) {
    // var ROOT_PATH = 'https://cdn.jsdelivr.net/gh/apache/echarts-website@asf-site/examples';
    var chartDom = document.getElementById(nodeDOM);
    var myChart = echarts.init(chartDom);
    params && myChart.setOption(params);
}


// WEBPACK FOOTER //
// ./src/assets/shareFuncation/Charts.js